export default {
  combine: {
    view_report: "@:ui.view报告",
    add_login: "@:ui.add@:ui.login",
    add_host: "@:ui.add@:ui.hosts",
    add_provider: "@:ui.add@:ui.providers",
    add_function: "@:ui.add@:ui.functions",
    add_page: "@:ui.add@:ui.pages",
    add_role: "@:ui.add@:ui.roles",
    add_user: "@:ui.add@:ui.users",
    edit_login: "@:ui.edit@:ui.login",
    edit_host: "@:ui.edit@:ui.hosts",
    edit_provider: "@:ui.edit@:ui.providers",
    edit_function: "@:ui.edit@:ui.functions",
    edit_page: "@:ui.edit@:ui.pages",
    edit_role: "@:ui.edit@:ui.roles",
    edit_user: "@:ui.edit@:ui.users",
    edit_password: "@:ui.edit@:ui.password",
    delete_login: "@:ui.delete@:ui.login",
    delete_host: "@:ui.delete@:ui.hosts",
    delete_provider: "@:ui.delete@:ui.providers",
    delete_function: "@:ui.delete@:ui.functions",
    delete_page: "@:ui.delete@:ui.pages",
    delete_role: "@:ui.delete@:ui.roles",
    delete_user: "@:ui.delete@:ui.users",
    assign_functions: "@:ui.assign@:ui.functions",
    assign_roles: "@:ui.assign@:ui.roles",
    confirm_password: "确认@:ui.password",
    change_password: "更改@:ui.password",
    old_password: "旧@:ui.password",
    new_password: "新@:ui.password",
    account_status: "@:ui.account@:ui.status",
    account_settings: "@:ui.account@:ui.settings",
    layout_settings: "@:ui.layout@:ui.settings",
    add_bot: "@:ui.add@:ui.bots",
    edit_bot: "@:ui.edit Bot",
    delete_bot: "@:ui.delete Bot",
    assign_bot_login: "@:ui.assign@:ui.bot_login",
    add_proxy: "@:ui.add@:ui.proxies",
    delete_proxy: "@:ui.delete@:ui.proxies",
    assign_bot_proxy: "@:ui.assign@:ui.bot_proxy"
  },
  short: {
    swap_team: "ST",
    manual_add: "MA",
    manual_map: "MM",
    manual_create: "MC",
    remap: "RM",
    mark_fetch: "F",
    affect_value: "AV",
    cmd_enabled: "CMD",
    match_date: "Date",
    market_type: "Market",
    match_time: "Time",
    match_link: "Link",
    running_score: "RS",
    running_time: "RT",
    parent_league: "PL",
    match_provider: "MP",
    league_provider: "LP",
    home_provider: "HP",
    away_provider: "AP"
  },
  ok: "确认",
  cancel: "取消",
  apply: "应用",
  login: "登录",
  logout: "登出",
  home: "主页",
  add: "添加",
  edit: "编辑",
  delete: "删除",
  refresh: "刷新",
  assign: "分配",
  action: "操作",
  id: "ID",
  name: "名称",
  all: "全部",
  search: "搜索",
  remove: "撤除",
  save: "保存",
  load: "加载",
  account: "帐户",
  settings: "设置",
  on: "开",
  off: "关",
  new: "新",
  clear: "清除",
  system: "系统",
  functions: "功能",
  pages: "页面",
  roles: "角色",
  users: "用户",
  username: "用户名",
  password: "密码",
  created_on: "创建于",
  active: "活跃",
  disabled: "禁用",
  blocked: "阻塞",
  suspended: "暂停",
  page_size: "页面大小",
  no_data: "没有数据",
  status: "状态",
  login_attempt: "登录尝试",
  user_roles: "角色",
  layout: "布局",
  mustang: "链接赔率",
  providers: "提供商",
  hosts: "主机",
  proxies: "代理",
  proxy_id: "代理ID",
  proxy_host: "代理主机",
  proxy_port: "代理端口",
  proxy_remark: "备注",
  ports: "端口",
  providerid: "提供商ID",
  url: "网址",
  hostid: "主机ID",
  fullname: "全名",
  view: "查看",
  moreinfo: "更多信息",
  robot: "机器",
  model: "型号",
  result: "结果",
  success: "成功",
  version: "版本",
  hostname: "主机名",
  ipaddress: "IP地址",
  machine: "机器  ",
  platform: "平台",
  cpupercentage: "CPU百分比",
  virtualmemory: "虚拟内存",
  runtime: "运行",
  target: "目标",
  server: "服务器",
  payload: "有效载荷",
  close: "关闭",
  omcache: "缓存",
  time: "时间",
  event: "赛事",
  hdp: "HDP",
  ou: "OU",
  oe: "OE",
  onextwo: "1X2",
  first_half: "上半场",
  odds: "赔率",
  even: "even",
  bots: "BOT",
  time_sync: "时间同步",
  bot_login: "BOT登录",
  free_login: "可用的登录",
  bot_proxy: "BOT代理",
  free_proxy: "可用的代理",
  full_time: "Full Time",
  half_time: "Half Time",
  first_goal: "First Goal",
  last_goal: "Last Goal",
  no_goal: "No Goal",
  double_chance: "Double Chance",
  total_goal: "Total Goal",
  hh: "HH",
  hd: "HD",
  ha: "HA",
  dh: "DH",
  dd: "DD",
  da: "DA",
  ah: "AH",
  ad: "AD",
  aa: "AA",
  ml: "ML",
  market: "市场",
  sports: "体育",
  sport_id: "体育ID",
  bet_type: "投注类型",
  back: "返回",
  show: "显示",
  matches: "球赛",
  leagues: "联盟",
  league_id: "联赛 ID",
  league_name: "联赛名称",
  sbo_link: "SBO Link",
  ibc_link: "IBC Link",
  cmd_link: "CMD Link",
  sbo: "SBO",
  ibc: "IBC",
  cmd: "CMD",
  sbo_map: "SBO Map",
  ibc_map: "IBC Map",
  cmd_map: "CMD Map",
  epoch_time: "Epoch Time",
  link_id: "链接ID",
  mark_fetch: "Mark Fetch",
  linked: "Linked",
  fetched: "Fetched",
  teams: "球队 | 球队",
  team_name: "队名",
  configuration: "配置",
  monitor: "监测",
  list: "主列表",
  login_id: "登录ID",
  login_name: "登录名",
  filter: "过滤",
  ascending: "顺序排列",
  descending: "逆序排列",
  map_league: "Map联盟",
  map_team: "Map球队",
  map_match: "Map球赛",
  mapped: "Mapped",
  not_mapped: "Not Mapped",
  map: "Map",
  unmap: "Unmap",
  match: "球赛",
  match_date: "比赛日期",
  market_type: "市场类型",
  match_link: "比赛链接",
  match_time: "比赛时间",
  is_live: "Is Live",
  sbo_match: "SBO Match",
  cmd_match: "CMD Match",
  ibc_match: "IBC Match",
  linked_match: "Linked Match",
  early: "Early",
  today: "Today",
  live: "Live",
  not_linked: "Not Linked",
  cmd_enabled: "CMD Enabled",
  affect_value: "Affect Value",
  semi_auto: "半自动",
  ldiff: "LDiff",
  auto_open: "自动开启",
  manual_link: "手动链接",
  job_control: "工作控制",
  reports: "报告 | 报告",
  odds_log: "赔率日志",
  odds_id: "赔率Id",
  match_id: "比赛Id",
  manual_add: "手动添加",
  manual_map: "手动Map",
  running_score: "运行比数",
  running_time: "运行时间",
  parent_league: "母联盟",
  ot: "赔率类型",
  mt: "市场类型",
  sync: "同步",
  sbo_login: "SBO登录",
  ibc_login: "IBC登录",
  cmd_login: "CMD登录",
  sbo_bot: "SBO机器人",
  ibc_bot: "IBC机器人",
  cmd_bot: "CMD机器人",
  logs: "日志 | 日志",
  action_log: "行动日志",
  date_time: "日期时间",
  status_desc: "状态描述",
  ip_address: "IP地址",
  domain_name: "域名",
  browser_agent: "浏览器代理",
  action_by: "行动人",
  target_id: "目标ID",
  target_action: "目标行动",
  details: "细节",
  key: "Key | Keys",
  value: "Value | Values",
  sort: "分类",
  next: "下一个",
  from: "从",
  to: "到",
  unmap_match: "Unmap比赛",
  unmap_list: "Unmap名单",
  match_provider: "比赛提供商",
  league_provider: "联盟提供商",
  home_provider: "主队提供商",
  away_provider: "客队提供商",
  update_mapping: "Update Mapping",
  duplicate_match_list: "重复比赛名单",
  current_match: "当前比赛",
  running_ball: "跑球",
  danger_zone: "危险区",
  match_feed: "比赛提要",
  rtf_commentary: "RTF评论",
  play_state: "比赛状态",
  play_time: "Play Time",
  info: "Info",
  last_info: "Last Info",
  rtf_name: "RTF Name",
  description: "Description",
  rtf: "RTF",
  report_stats: "Report Statistics",
  rtf_id: "RTF Id",
  rtf_name: "RTF Name",
  last_update_time: "Last Update Time",
  event_id: "Event Id",
  map_outright: "Map Outright",
  remap_match: "Remap Match",
  remap: "Remap",
  sbo_prefer: "SBO Prefer",
  ibc_prefer: "IBC Prefer",
  change_date: "Change Date",
  match_datetime: "Match DateTime",
  current_league: "Current League",
  remap_league: "Remap League",
  remap_team: "Remap Team",
  sbo_league: "SBO League",
  ibc_league: "IBC League",
  current_team: "Current Team",
  sbo_team: "SBO Team",
  ibc_team: "IBC Team",
  prefer: "Prefer",
  create: "Create",
  linked_match_info: "Linked Match Info",
  sbo_match_info: "SBO Match Info",
  ibc_match_info: "IBC Match Info",
  match_info: "Match Info",
  match_datetime: "Match DateTime",
  manual_create: "Manual Create",
  pre_add_match: "Pre Add Match",
  pre_add_match_cmd: "Pre Add Match CMD",
  console: "Console",
  check: "Check",

};
